// extracted by mini-css-extract-plugin
module.exports = {"wrFooter":"WrFooter_wrFooter__2p3n6","container":"WrFooter_container__2Ok54","nets":"WrFooter_nets__1l_CB","net":"WrFooter_net__IM0x2","social":"WrFooter_social__yx_iQ"};